<div class="space-y-[16px]">
  <div class="grid grid-cols-1 gap-[12px] md:grid-cols-2" role="group" aria-label="Canales de venta">
    <button type="button" *ngFor="let c of DEF" class="cv-canal"
            [class.cv-canal-si]="tiene(c.codigo)" [class.cv-canal-fijo]="c.fijo"
            [attr.aria-pressed]="tiene(c.codigo)" [attr.data-kb-tip]="c.fijo ? 'Va siempre: es donde entra el comercio' : null"
            (click)="alternar(c)">
      <span class="cv-canal-check" aria-hidden="true"><i class="fas fa-check" *ngIf="tiene(c.codigo)"></i></span>
      <span class="min-w-0">
        <span class="cv-canal-nombre">{{ c.nombre }}<span class="kb-badge kb-badge-contorno ml-2" *ngIf="c.fijo">siempre</span></span>
        <span class="cv-canal-detalle">{{ c.detalle }}</span>
      </span>
    </button>
  </div>
  <div class="kb-aviso kb-aviso-info" role="status">
    <b>Va a vender por:</b> {{ nombres }}.
    <ul class="m-0 mt-1 list-disc pl-5" *ngIf="pideTecnico || pideVendedor">
      <li *ngIf="pideTecnico">Por esos canales se necesita el contacto técnico: a él le llegan las llaves. Se pide en «Contactos» y es obligatorio.</li>
      <li *ngIf="pideVendedor">Con link de pago se necesita un vendedor: se carga en «Tienda y caja».</li>
    </ul>
  </div>
</div>
